var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2711 0.470703H5.27107C4.60927 0.470703 4.07107 1.0089 4.07107 1.6707V4.0707H1.67107C1.00927 4.0707 0.471069 4.6089 0.471069 5.2707V11.2707C0.471069 11.9325 1.00927 12.4707 1.67107 12.4707H7.67107C8.33287 12.4707 8.87107 11.9325 8.87107 11.2707V8.8707H11.2711C11.9329 8.8707 12.4711 8.3325 12.4711 7.6707V1.6707C12.4711 1.0089 11.9329 0.470703 11.2711 0.470703ZM1.67107 11.2707V5.2707H7.67107L7.67227 11.2707H1.67107ZM11.2711 7.6707H8.87107V5.2707C8.87107 4.6089 8.33287 4.0707 7.67107 4.0707H5.27107V1.6707H11.2711V7.6707Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.29f39c6f.svg";
export { ForwardRef as ReactComponent };